import Vue from 'vue';
/**
 *  A store for handling the application drag data. Non persisting store.
 */
const state = {
  /**
   * Describes the drag item(s)
   */
  items: {
    type: null,
    ids: [],
  },
  /**
   * Describes the source list container(s). There is a possibly different container for each item in drag.
   */
  source: {
    type: null,
    ids: [],
    indexes: [],
  },
  /**
   * Describes the target list container. There is only one target container.
   */
  target: {
    type: null,
    id: null,
    index: null,
  },
};

const getters = {
  /**
   * Return the current item part of the drag
   * @returns {Object}
   */
  getItems(state) {
    return state.items;
  },
  /**
   * Return the current source part of the drag
   * @returns {Object}
   */
  getSource(state) {
    return state.source;
  },
  /**
   * Return the current target part of the drag
   * @returns {Object}
   */
  getTarget(state) {
    return state.target;
  },
  /**
   * Return whether drag is empty
   * @returns {Boolean}
   */
  getIsEmpty(state) {
    return !state.items.type && state.items.ids.length === 0;
  },
};

const actions = {
  /**
   * Set the current item part of the drag
   */
  setItems(context, { value }) {
    context.commit('setItems', { value });
  },
  /**
   * Set the current source part of the drag
   */
  setSource(context, { value }) {
    context.commit('setSource', { value });
  },
  /**
   * Set the current target part of the drag
   */
  setTarget(context, { value }) {
    context.commit('setTarget', { value });
  },
  /**
   * Clear the drag
   */
  clear(context) {
    context.commit('setItems', {
      value: {
        type: null,
        ids: [],
      },
    });
    context.commit('setSource', {
      value: {
        type: null,
        ids: [],
        indexes: [],
      },
    });
    context.commit('setTarget', {
      value: {
        type: null,
        id: null,
        index: null,
      },
    });
  },
};

const mutations = {
  /**
   * Set the current item part of the drag
   */
  setItems(state, { value }) {
    state.items = value;
  },
  /**
   * Set the current source part of the drag
   */
  setSource(state, { value }) {
    state.source = value;
  },
  /**
   * Set the current target part of the drag
   */
  setTarget(state, { value }) {
    state.target = value;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
